<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import CgsbwhBrowse from "./CgsbwhBrowse";
import CgsbwhEdit from "./CgsbwhEdit";
import CgsbwhView from "./CgsbwhView";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "Cgsbwh",
    components: { CgsbwhBrowse, CgsbwhEdit, CgsbwhView },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showView: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.setNoticeId(null);
            this.editProps.showEdit = true;
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            if (this.editProps.showEdit === true) {
                return "CgsbwhEdit";
            } else if (this.editProps.showView === true) {
                return "CgsbwhView";
            } else {
                return "CgsbwhBrowse";
            }
        }
    },
    methods: {
        ...mapActions(["setNoticeId"])
    }
};
</script>
